<script>
import featureFlagResolver from '_utils_/featureFlagResolver.js';

export default {
	name: 'FeatureFlagMixin',
	computed: {
		afisShareClass3Enabled() {
			return featureFlagResolver.isEnabled('afisShareClass3');
		}
	}
};
</script>
